export const TYPE_LABELS = {
  laboratory: "Laboratuvar",
  imaging: "Görüntüleme",
};

export const TYPE_OPTIONS = [
  { value: "", label: "Tüm tipler" },
  { value: "laboratory", label: TYPE_LABELS.laboratory },
  { value: "imaging", label: TYPE_LABELS.imaging },
];

export const STATUS_META = {
  requested: { label: "İstendi", tone: "neutral" },
  in_progress: { label: "Yapılıyor", tone: "warning" },
  completed: { label: "Tamamlandı", tone: "success" },
  cancelled: { label: "İptal", tone: "error" },
};

/** Kaydın normalize edilmiş durum anahtarı — bilinmeyen değerler `requested`. */
export function getStatusKey(record) {
  const key = String(record?.status || "requested").toLowerCase();
  return STATUS_META[key] ? key : "requested";
}

/** Tetkikteki test / görüntüleme adları. */
export function itemNames(record) {
  if (record?.type === "imaging") {
    return (record.imagingItems || []).map((i) => i?.name || i?.label || i?.image?.name).filter(Boolean);
  }
  return (record?.laboratoryItems || []).map((i) => i?.name || i?.labTest?.name).filter(Boolean);
}
